import { Component, Inject, OnInit } from '@angular/core';
import { SystemsInInventoryViewModel } from '../inventory-models';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
item:SystemsInInventoryViewModel
}
@Component({
  selector: 'app-inventory-or-wsre-dialog',
  templateUrl: './inventory-or-wsre-dialog.component.html',
  styleUrls: ['./inventory-or-wsre-dialog.component.scss']
})
export class InventoryOrWsreDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<InventoryOrWsreDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) { }

systemType :number=1;

  ngOnInit() {
console.log("InventoryOrWsreDialogComponent", this.data.item)
this.systemType = this.data.item.SystemType;

  }


  onNoClick() {
    this.dialogRef.close(0);
  }

  Open(){
    this.dialogRef.close(1);
  }
  
  StartInspection(){
    this.dialogRef.close(2);
  }
  StartInspectionFrame(){
    this.dialogRef.close(3);
  }
 
}
